
// 简历模板icon
export const TEMPLATE_IMAGES = {
  zero: 'https://files.wondercv.com/PC/cvs/resume_icon/greenhand.png',
  stu: 'https://files.wondercv.com/PC/cvs/resume_icon/student.png',
  white: 'https://files.wondercv.com/PC/cvs/resume_icon/postgraduate.png',
  bank: 'https://files.wondercv.com/PC/cvs/resume_icon/work.png',
  aboard_ba: 'https://files.wondercv.com/PC/cvs/resume_icon/banking.png',
  grad: 'https://files.wondercv.com/PC/cvs/resume_icon/pm.png',
  programmer: 'https://files.wondercv.com/PC/cvs/resume_icon/developer.png',
  product: 'https://files.wondercv.com/PC/cvs/resume_icon/overseas.png'
};



// 简历标题颜色
export const THEME = [ "#000000", "#CA3832", "#EE8732", "#4183FF", "#9C5BDE", "#6DB557"];
// 简历顶部线条颜色
export const HEADER_LINE_THEME = ['#404040', '#CA3832', '#EE8732', '#4183FF', '#9C5BDE', '#6DB557'];

export const FONT_SIZE = ['10pt', '11pt', '12pt', '13pt', '14pt', '15pt', '16pt', '17pt', '18pt'];

export const FONT = {
  cn: [
    {
      id: 'font-1',
      name: ['PingFang SC','Microsoft YaHei'],
      cnName: '微软雅黑',
      iconfont:'iconweiruanyahei',
    },
    {
      id: 'font-1004',
      name: ['SimHei', 'STHeiti'],
      cnName: '黑体',
      iconfont:'iconheiti',
    },
    {
      id: 'font-2',
      name: ['Source Han Serif SC','SimSun','STSong'],
      cnName: '宋体',
      iconfont:'iconsongti',
    },
    {
      id: 'font-3',
      name: ['KaiTi', 'STKaiti','STKaitiSc'],
      cnName: '楷体',
      iconfont:'iconkaiti',
    },
    {
      id: 'font-1005',
      name: ['FangSong','STFangsong'],
      cnName: '仿宋',
      iconfont:'iconfangsong',
    },
  ],
  en: [
    {
      id: 'font-4',
      name: ['Arial'],
      cnName: 'Arial',
      iconfont:'iconArial',
    },
    {
      id: 'font-5',
      name: ['Helvetica'],
      cnName: 'Helvetica',
      iconfont:'iconHelvetica',
    },
    {
      id: 'font-6',
      name: ['Georgia'],
      cnName: 'Georgia',
      iconfont:'iconGeorgia',
    },
    {
      id: 'font-7',
      name: ['Times New Roman'],
      cnName: 'Times New Roman',
      iconfont:'iconTimesNewRoman',
    },
    {
      id: 'font-2005',
      name: ['Droid Serif'],
      cnName: 'Droid Serif',
      iconfont:'iconDroidSerif',
    },
    {
      id: 'font-2006',
      name: ['Source Code Pro'],
      cnName: 'Source Code Pro',
      iconfont:'iconSourceCodePro',
    },
  ]
}

export const LINE_HEIGHT = [12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28];

export const PAGE_PADDING = [5, 10, 15, 20, 25];

export const MONTH_PRICE = 19.9;
export const YEAR_PRICE = 79.9;
export const FOREVER_PRICE = 99.9;
export const WONDER_PRICE = 169.9;
export const FOREVER_PLUS_PRICE = 119.9;

export const NORMAL = 1;

export const ORDER_IN = 2;

export const ORDER_OUTSIDE = 3;

export const BUY_IN = 4;

export const BUY_OUTSIDE = 5;

export const PERMANENT_MEMBER = 6;

export const CLOSE = 7

export const ORDER_IN_COUNTDOWN = {
  nav: {
    title: 'https://logo.wondercv.com/banners/uuDSybsTskVOnGH.png'
  },
  isCountdown: true,
  couponList: [
    // {
    //   money: 2,
    //   couponTitle: '月度优惠券',
    //   couponDesc: '有效期：10分钟',
    //   type: 'month',
    //   backgroundImage: 'https://logo.wondercv.com/banners/HTyNCYXi4axbYw9.png'
    // },
    {
      money: 20,
      couponTitle: '终身优惠券',
      couponDesc: '有效期：10分钟',
      type: 'forever',
      // backgroundImage: 'https://logo.wondercv.com/banners/HTyNCYXi4axbYw9.png'
      backgroundImage: 'https://logo.wondercv.com/banners/KTWWL345cXCLN7m.png'
    }
  ],
}

export const ORDER_OUTSIDE_COUNTDOWN = {
  nav: {
    title: 'https://logo.wondercv.com/banners/d0V8Bt5nvPj42ld.png',
  },
  isCountdown: false,
  couponList: []
}

export const BUY_IN_COUNTDOWN = {
  isCountdown: true,
  nav: {
    title: 'https://logo.wondercv.com/banners/UJYZM1FI9JPgbCy.png'
  },
  couponList: [
    {
      money: 40,
      couponTitle: '终身优惠券',
      couponDesc: '领取后 24 小时内有效',
      type: 'forever',
      backgroundImage: 'https://logo.wondercv.com/banners/KTWWL345cXCLN7m.png'
    },
  ],
  buttonInfo: {
    icon: 'iconhuaban',
    text: '立即购买'
  }
}

export const BUY_OUTSIDE_COUNTDOWN = {
  isCountdown: false,
  nav: {
    title: 'https://logo.wondercv.com/banners/d0V8Bt5nvPj42ld.png'
  },
  couponList: [],
  buttonInfo: {
    icon: 'iconhuaban',
    text: '升级会员'
  }
}

export const MEMBER_BASE_DATA = {
  title: '超级会员·做专业简历拿高薪Offer',
  couponList: [],
  introList: [
    {
      countFiled: 'cv_count',
      totalCountField: 'cv_all_count',
      memberName: '简历份数',
      icon: 'iconAIzhinengjiancha',
      name: 'AI智能检查'
    },
    {
      countFiled: 'cv_check_count',
      totalCountField: 'cv_check_all_count',
      memberName: '智能检查',
      icon: 'iconhailiangdaniumoban',
      name: '海量大牛模版'
    },
    {
      countFiled: 'cv_trans_count',
      totalCountField: 'cv_trans_all_count',
      memberName: '一键翻译',
      icon: 'iconzhongyingyijianfanyi',
      name: '中英一键翻译'
    },
    {
      countFiled: '',
      totalCountField: '',
      memberName: '简历样式',
      icon: 'iconyangshiwuxianzhi',
      name: '样式无限制'
    },
    {
      countFiled: 'id_photo_count',
      totalCountField: 'id_photo_all_count',
      memberName: '证件照',
      icon: 'iconzhengjianzhaozhizuo',
      name: '证件照制作'
    },
    {
      countFiled: 'find_error_count',
      totalCountField: 'find_error_all_count',
      memberName: '简历纠错',
      icon: 'iconhuiyuanqiuzhishequn',
      name: '会员求职社群'
    },
    {
      countFiled: 'ai_interview_count',
      totalCountField: 'ai_interview_all_count',
      memberName: 'AI模拟面试',
      icon: 'icona-AImonimianshi',
      name: 'AI模拟面试'
    },
    {
      countFiled: 'ai_cv_optimize_count',
      totalCountField: 'ai_cv_optimize_all_count',
      memberName: 'AI简历润色',
      icon: 'icona-AIjianlirunse',
      name: 'AI简历润色'
    },
  ],
  moreText: '更多权益',
}

export const MEMBER_STATE_DATA = {
  [NORMAL]: {
    ...MEMBER_BASE_DATA,
    image: 'https://logo.wondercv.com/banners/FwWp9xkDJMVj4kb.png',
    subTitle: '求职路上保驾护航',
    nav: {
      title: 'https://logo.wondercv.com/banners/Pb4dfxM1WRF3sJg.png'
    },
    buttonInfo: {
      icon: 'iconhuaban',
      text: '特惠购买'
    },
  },
  [CLOSE]: {
    ...MEMBER_BASE_DATA,
    image: 'https://logo.wondercv.com/banners/FwWp9xkDJMVj4kb.png',
    subTitle: '求职路上保驾护航',
    nav: {
      title: 'https://logo.wondercv.com/banners/Pb4dfxM1WRF3sJg.png'
    },
    buttonInfo: {
      icon: 'iconhuaban',
      text: '特惠购买'
    },
  },
  [ORDER_IN]: {
    ...MEMBER_BASE_DATA,
    title: '超级会员·限时优惠',
    buttonInfo: {
      icon: 'iconhuaban',
      text: '立即购买'
    },
    duration: 10 * 60,
    ...ORDER_IN_COUNTDOWN,
  },
  [ORDER_OUTSIDE]: {
    ...MEMBER_BASE_DATA,
    image: 'https://logo.wondercv.com/banners/FwWp9xkDJMVj4kb.png',
    subTitle: '求职路上保驾护航',
    buttonInfo: {
      icon: 'iconhuaban',
      text: '立即购买'
    },
    ...ORDER_OUTSIDE_COUNTDOWN,
  },
  [BUY_IN]: {
    ...MEMBER_BASE_DATA,
    title: '超级会员·限时优惠',
    duration: 60 * 60 * 24,
    buttonInfo: {
      icon: 'iconhuaban',
      text: '立即购买'
    },
    ...BUY_IN_COUNTDOWN,
  },
  [BUY_OUTSIDE]: {
    ...MEMBER_BASE_DATA,
    ...BUY_OUTSIDE_COUNTDOWN,
  },
  [PERMANENT_MEMBER]: {
    ...MEMBER_BASE_DATA,
    nav: {
      title: 'https://logo.wondercv.com/banners/d0V8Bt5nvPj42ld.png'
    },
    buttonInfo: {
      icon: 'iconhuaban',
      text: '会员中心'
    },
  }
};